<template>
  <div>
    <!-- filter -->
    <filter-for-grid
      :views-dropdown="true"
      :query-params.sync="query_params"
      :active-view.sync="active_view"
      :filters="['rooms_count', 'area', 'price', 'status']"
      @delayedFilter="delayedFilter"
      @filterFlats="filterFlats"
      @apartmentChanged="apartmentChanged"
    />

    <!-- <b-card class="d-flex">
      <b-row class="p-2">
        <b-form-group
          :label="$t('objects.numbers_room')+':'"
        >
          <b-form-checkbox-group
            v-model="query_params.rooms_count_list"
            :options="GET_ROOMS_COUNT_BY_APARTMENT"
            buttons
            button-variant="outline-primary"
            size="md"
            name="buttons-2"
            @change="filterFlats"
          />
        </b-form-group>
        <b-col
          md="4"
          sm="12"
        >
          <b-form-group
            :label="$t('objects.price')+':'"
            class="d-flex"
          >
            <div class="d-flex">
              <b-input-group
                class="mr-1"
                :prepend="$t('objects.from')"
              >
                <cleave
                  id="number-start"
                  v-model="query_params.total_price_start"
                  class="form-control"
                  :raw="true"
                  :options="config"
                  placeholder="10,000"
                  @input="delayedFilter"
                />
              </b-input-group>
              <b-input-group :prepend="$t('objects.to')">
                <cleave
                  id="number-end"
                  v-model="query_params.total_price_end"
                  class="form-control"
                  :raw="true"
                  :options="config"
                  placeholder="10,000"
                  @input="delayedFilter"
                />
              </b-input-group>
            </div>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          sm="12"
        >
          <b-form-group
            :label="$t('objects.area')+':'"
            class="d-flex"
          >
            <div class="d-flex">
              <b-input-group
                class="mr-1"
                :prepend="$t('objects.from')"
              >
                <b-form-input
                  v-model="query_params.total_area_start"
                  @input="delayedFilter"
                />
              </b-input-group>
              <b-input-group :prepend="$t('objects.to')">
                <b-form-input
                  v-model="query_params.total_area_end"
                  @input="delayedFilter"
                />
              </b-input-group>
            </div>
          </b-form-group>
        </b-col>
        <div class="ml-auto">
          <b-form-group :label="$t('objects.view')">
            <b-dropdown
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              right
              menu-class="w-100"
            >
              <template #button-content>
                <feather-icon :icon="getActiveView.icon" />
                {{ getActiveView.text }}
              </template>
              <b-dropdown-item
                v-for="option in view_options"
                :key="option.id"
                @click="changeView(option.id)"
              >
                <feather-icon :icon="option.icon" />
                {{ option.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-form-group>
        </div>
      </b-row>
      <div class="d-flex">
        <b-form-group
          :label="$t('objects.status')+':'"
        >
          <b-form-checkbox-group
            v-model="query_params.current_status"
            size="md"
            @change="filterFlats"
          >
            <b-form-checkbox
              v-for="option in GET_FLAT_STATUSES"
              :key="option.id"
              :class="`custom-control-${option.color}`"
              :value="option.id"
            >
              {{ option.title[$i18n.locale] }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </b-card> -->

    <!-- shaxmatka view -->
    <b-card v-if="active_view === 1">
      <b-overlay :show="overlay" rounded="lg" opacity="0.6">
        <vue-selecto
          :data="GET_CHECKERBOARD_LAYOUT"
          :sidebar="true"
          :filter="query_params"
          @flatSelected="openRightSidebar"
        />
      </b-overlay>
    </b-card>
    <!-- list view (Список) -->
    <section v-if="active_view === 2">
      <table-view
        @rowItemClicked="openRightSidebar"
        @changePage="changePage"
        @changePerPage="changePerPage"
      />
    </section>

    <section v-if="active_view === 3">
      <card-view
        :plannings="GET_FLATS_PLANNINGS"
        @photoClicked="showInLargeSize"
        @moreInfoClick="openRightSidebar"
        @flatSelected="openRightSidebar"
      />
    </section>
    <right-sidebar
      v-model="right_sidebar"
      :item="selected_flat"
      :flat-choosing="false"
      @photoClicked="showInLargeSize"
      @oformit="oformit"
    />
    <left-sidebar v-model="left_sidebar" :image="selected_image" />
    <AddCostFlatModal :flat-id="flatId" />
  </div>
</template>

<script>
import {
  // BFormGroup, BFormCheckboxGroup, BFormInput, BInputGroup, BDropdownItem, BDropdown, BRow, BCol,
  // BBadge,
  BCard,
  BOverlay,
  // BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
// import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
// import Cleave from 'vue-cleave-component'
import Ripple from "vue-ripple-directive";
import vueSelecto from "@/components/vueSelecto.vue";
import tableView from "./components/flatsTable.vue";
import cardView from "./components/cardsView.vue";
import rightSidebar from "./components/flatSidebar.vue";
import leftSidebar from "./components/leftImageSidebar.vue";
import filterForGrid from "./components/filterForGrid.vue";
import flatStatuses from "@/mixins/flat_statuses";
import AddCostFlatModal from "./components/modals/AddCostFlatModal.vue";

export default {
  directives: {
    Ripple,
  },
  components: {
    vueSelecto,
    AddCostFlatModal,
    // BFormGroup,
    // BFormCheckboxGroup,
    // BFormInput,
    // BInputGroup,
    // Cleave,
    // BDropdownItem,
    // BDropdown,
    // FeatherIcon,
    // BRow,
    // BCol,
    tableView,
    rightSidebar,
    cardView,
    // BBadge,
    leftSidebar,
    BCard,
    // BFormCheckbox,
    filterForGrid,
    BOverlay,
  },
  mixins: [flatStatuses],
  props: {
    id: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      query_params: {
        id: this.id,
        page: 1,
        page_size: 5,
        apartment: this.id,
        rooms_count_list: [],
        total_area_start: "",
        total_area_end: "",
        total_price_end: "",
        total_price_start: "",
        current_status: [],
      },
      flatId: null,
      selected_flat: {
        current_status: {
          title: {},
        },
      },
      selected_image: "",
      left_sidebar: false,
      right_sidebar: false,
      active_view: 1,
      delay: null,
      overlay: false,
    };
  },
  computed: {
    ...mapGetters("apartments", [
      "GET_CHECKERBOARD_LAYOUT",
      "GET_ONE_APARTMENT",
      "GET_APARTMENT_MAIN_INFO",
      "GET_ROOMS_COUNT_BY_APARTMENT",
    ]),
    ...mapGetters("flats", ["GET_FLATS_PLANNINGS", "GET_ONE_FLAT"]),
    ...mapGetters("stages", ["GET_STAGE_PLANNINGS"]),
    ...mapGetters("knowledgeBase", ["GET_FLAT_STATUSES"]),
    getActiveView() {
      return this.view_options.find((el) => el.id === this.active_view);
    },
    // getPlannings() {
    //   if (this.GET_STAGE_PLANNINGS.length) {
    //     return
    //   }
    //   return [
    //     {
    //       image: 'https://picsum.photos/1024/840/?image=41',
    //     },
    //   ]
    // },
    getShaxmatka() {
      return this.GET_CHECKERBOARD_LAYOUT;
    },
    getFlatsForTable() {
      return [
        {
          total_price: 250000000,
          status: {
            id: 1,
            text: this.$t("objects.freely"),
            color: "success",
          },
          section: 1,
          stage: 1,
          flat_number: 1,
          rooms_count: 4,
          price_for_square_meter: 2500000,
          total_area: 100,
        },
      ];
    },
  },
  watch: {
    active_view() {
      this.refresh();
    },
    // 'query_params.total_area_start': async function () {
    //   this.delayedFilter()
    // },
    // 'query_params.total_area_end': async function () {
    //   this.delayedFilter()
    // },
  },
  mounted() {
    if (this.id) {
      this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(this.id);
      this.FETCH_ONE_APARTMENT(this.id).then(() => {
        this.updateBreadcrumb();
      });
      this.FETCH_ROOMS_COUNT_BY_APARTMENT(this.id);
    }
  },
  destroyed() {
    this.SET_APARTMENT_CHECKERBOARD_LAYOUT([]);
  },
  methods: {
    ...mapActions("apartments", [
      "FETCH_APARTMENT_CHECKERBOARD_LAYOUT",
      "FETCH_ONE_APARTMENT",
      "FETCH_ROOMS_COUNT_BY_APARTMENT",
      "BOOK_FLAT",
    ]),
    ...mapActions("stages", ["FETCH_STAGE_PLANNINGS"]),
    ...mapActions("flats", [
      "FETCH_FLATS_BY_APARTMENT",
      "FETCH_FLATS_PLANNINGS",
      "FETCH_FLATS_PLANNINGS_BY_APARTMENT",
      "FETCH_ONE_FLAT",
      "EDIT_FLAT",
    ]),
    ...mapMutations("breadcrumb", ["UPDATE_BREADCRUMB"]),
    ...mapMutations("apartments", ["SET_APARTMENT_CHECKERBOARD_LAYOUT"]),
    changeView(id) {
      this.active_view = id;
    },
    filterFlats() {
      this.query_params.page = 1;
      // console.log(this.query_params)
      if (this.active_view !== 1) {
        this.refresh();
      }
    },
    changePage(val) {
      console.log(val);
      this.query_params.page = val;
      this.refresh();
    },
    changePerPage(val) {
      this.query_params.page_size = val;
      this.refresh();
    },
    delayedFilter() {
      clearTimeout(this.delay);
      this.delay = setTimeout(() => {
        this.filterFlats();
      }, 800);
    },
    openRightSidebar(flat) {
      this.selected_flat = flat;
      this.FETCH_ONE_FLAT(flat.id).then(() => {
        this.selected_flat = this.GET_ONE_FLAT;
      });
      this.right_sidebar = true;
    },
    refresh() {
      if (this.active_view === 2) {
        this.FETCH_FLATS_BY_APARTMENT(this.query_params);
      } else if (this.active_view === 3) {
        // this.FETCH_FLATS_PLANNINGS(this.query_params)
        this.FETCH_FLATS_PLANNINGS_BY_APARTMENT(this.query_params);
      } else if (this.active_view === 1) {
        this.overlay = true;
        this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(
          this.query_params.apartment,
        ).then(() => {
          this.overlay = false;
        });
      }
    },
    showInLargeSize(url) {
      this.selected_image = url;
      this.left_sidebar = true;
    },
    updateBreadcrumb() {
      const [first, second, third, fourth] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb,
      );
      second.text = this.GET_APARTMENT_MAIN_INFO.rc_object;
      third.text = this.GET_APARTMENT_MAIN_INFO.title;
      second.to = second.to.replace(":id", this.GET_ONE_APARTMENT.rc_object);
      third.to = third.to.replace(":id", this.GET_ONE_APARTMENT.id);
      this.UPDATE_BREADCRUMB([first, second, third, fourth]);
    },
    apartmentChanged(apartment) {
      console.log(apartment);
      this.query_params.apartment = apartment;
      this.refresh();
    },
    oformit(id) {
      this.EDIT_FLAT({
        id,
        current_status: this.flat_statuses.registered,
      }).then(() => {
        this.$_successToast(this.$t("generals.success"));
        this.refresh();
        this.FETCH_ONE_FLAT(id).then(() => {
          this.selected_flat = this.GET_ONE_FLAT;
        });
        this.flatId = id;
        this.$nextTick(() => {
          this.$bvModal.show("add-cost-modal");
        });
      });
    },
  },
};
</script>

<style></style>
